<template>
  <v-btn id="import-button" small color="primary" class="ml-2 px-2 elevation-0" @click="click">
    <v-icon :size="isMobile ? 18 : 18" class="import-button-icon">mdi-file-upload-outline</v-icon>
    <span v-if="!isMobile" class="button-text px-1">
      {{ $t('views.common.importButton.import') }}
    </span>
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    click: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState(['user']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
}
</script>

<style lang="scss">
#import-button {
  margin-top: 1px;
  .import-button-icon {
    margin-bottom: 2px;
  }
  .button-text {
    // font-weight: 500;
  }
}
</style>
